import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Plus, Trash2, Clock } from "lucide-react";

const statusColors = {
  pending: "bg-amber-50 text-amber-700",
  approved: "bg-emerald-50 text-emerald-700",
  rejected: "bg-red-50 text-red-700",
};

const activityLabels = {
  volunteer: "Volunteering",
  training: "Training",
  community_service: "Community Service",
  mentoring: "Mentoring",
  other: "Other",
};

export const HoursTab = ({ hourLogs, hourForm, setHourForm, isSubmitting, onLogHours, onDeleteLog }) => (
  <div className="space-y-6">
    <div className="bg-white rounded-xl border border-gray-100 p-6">
      <h3 className="font-semibold text-gray-900 mb-4 flex items-center gap-2">
        <Plus className="w-5 h-5 text-warm-700" /> Log New Hours
      </h3>
      <form onSubmit={onLogHours} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <Label className="text-sm text-gray-700">Date</Label>
          <Input data-testid="hour-date" type="date" value={hourForm.date} onChange={e => setHourForm({ ...hourForm, date: e.target.value })} required className="mt-1" />
        </div>
        <div>
          <Label className="text-sm text-gray-700">Hours</Label>
          <Input data-testid="hour-amount" type="number" step="0.5" min="0.5" max="24" value={hourForm.hours} onChange={e => setHourForm({ ...hourForm, hours: e.target.value })} required placeholder="e.g. 4" className="mt-1" />
        </div>
        <div>
          <Label className="text-sm text-gray-700">Activity Type</Label>
          <select data-testid="hour-activity" value={hourForm.activity_type} onChange={e => setHourForm({ ...hourForm, activity_type: e.target.value })} className="mt-1 w-full border border-gray-200 rounded-lg px-3 py-2 text-sm">
            <option value="volunteer">Volunteering</option>
            <option value="training">Training</option>
            <option value="community_service">Community Service</option>
            <option value="mentoring">Mentoring</option>
            <option value="other">Other</option>
          </select>
        </div>
        <div>
          <Label className="text-sm text-gray-700">Description</Label>
          <Input data-testid="hour-description" value={hourForm.description} onChange={e => setHourForm({ ...hourForm, description: e.target.value })} placeholder="What did you do?" className="mt-1" />
        </div>
        <div className="sm:col-span-2">
          <Button type="submit" data-testid="hour-submit" disabled={isSubmitting} className="bg-warm-700 hover:bg-warm-800 text-white rounded-xl">
            {isSubmitting ? "Submitting..." : "Submit Hours"}
          </Button>
        </div>
      </form>
    </div>

    {hourLogs && (
      <div className="bg-white rounded-xl border border-gray-100">
        <div className="p-5 border-b border-gray-100">
          <div className="flex items-center justify-between">
            <h3 className="font-semibold text-gray-900">Hour Log History</h3>
            <div className="flex gap-4 text-sm">
              <span className="text-emerald-700 font-medium">{hourLogs.total_approved_hours}h approved</span>
              <span className="text-amber-600 font-medium">{hourLogs.total_pending_hours}h pending</span>
            </div>
          </div>
        </div>
        {hourLogs.logs.length === 0 ? (
          <div className="p-12 text-center text-gray-400">
            <Clock className="w-10 h-10 mx-auto mb-3 opacity-50" />
            <p className="text-sm">No hours logged yet. Start by submitting your first entry above.</p>
          </div>
        ) : (
          <div className="divide-y divide-gray-50">
            {hourLogs.logs.map(log => (
              <div key={log.id} className="px-5 py-4 flex items-center justify-between hover:bg-gray-50/50">
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <p className="text-sm font-medium text-gray-900">{activityLabels[log.activity_type] || log.activity_type}</p>
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${statusColors[log.status]}`}>
                      {log.status}
                    </span>
                  </div>
                  <p className="text-xs text-gray-500 mt-0.5">{log.date} - {log.hours} hours{log.description ? ` - ${log.description}` : ""}</p>
                </div>
                {log.status === "pending" && (
                  <button onClick={() => onDeleteLog(log.id)} className="p-2 text-gray-400 hover:text-red-500 transition-colors">
                    <Trash2 className="w-4 h-4" />
                  </button>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    )}
  </div>
);
